import React from "react";

import { useParams } from "react-router-dom";

import { useQuery, useMutation } from "@apollo/client";

// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

import mapDashboardValues from "./map-dashboard-values";

import DashboardCreate from "./dashboard-create";

interface Props {
  onClose?: any;
  onSuccess?: any;
  onError?: any;
}

const dashboard = gql`
  query dashboard($where: DashboardWhereUniqueInput!) {
    dashboard(where: $where)
    @rest(type: "Dashboard", path: "dashboard/{args.where.id}") {
      id
      title
      owner
      group
      permissionOwner
      permissionGroup
      permissionOther
      publicAvailable
      widgets @type(name: "Widget") {
        id
        title
        type
        interval @type(name: "DateRange") {
          startDate
          endDate
        }

        panelId
        layout @type(name: "WidgetLayout") {
          x
          y
          width
          height
          minWidth
          maxWidth
          minHeight
          maxHeight
        }
      }
    }
  }
`;

const createDashboard = gql`
  mutation createDashboard($data: DashboardCreateInput!) {
    createDashboard(data: $data)
    @rest(
      type: "Dashboard"
      path: "dashboard/"
      method: "POST"
      bodyKey: "data"
    ) {
      id
      title
      owner
      group
      permissionOwner
      permissionGroup
      permissionOther
      publicAvailable
      widgets @type(name: "Widget") {
        id
        title
        type
        interval @type(name: "DateRange") {
          startDate
          endDate
        }

        panelId
        layout @type(name: "WidgetLayout") {
          x
          y
          width
          height
          minWidth
          maxWidth
          minHeight
          maxHeight
        }
      }
    }
  }
`;

function DashboardDuplicateContainer(props: Props) {
  const { onClose } = props;

  const { id } = useParams<any>();

  const defaultValues = {
    permissionOwner: "READWRITE",
    permissionGroup: "READ",
    permissionOther: "NONE",
    publicAvailable: false,
  };

  const { data /*, error*/ } = useQuery(dashboard, {
    variables: { where: { id /*: entityId*/ } },
  });

  // if (error) return `Error! ${error.message}`;

  const entity = data ? data.dashboard : undefined;
  const { /*entity,*/ onSuccess /*, onError*/ } = props;
  if (entity) {
    entity.id = undefined;
    if (entity.title) {
      entity.title = `Copy of ${entity.title}`;
    }
    if (entity.widgets) {
      entity.widgets.forEach((widget: any) => {
        widget.id = undefined;
      });
    }
  }

  const [createDashboardMutation] = useMutation(createDashboard);
  async function saveEntity(values: any) {
    const options: any = {
      variables: { data: { ...mapDashboardValues(values, "create") } },
      refetchQueries: ["dashboards"],
    };
    await createDashboardMutation(options);

    if (onSuccess) {
      onSuccess();
    }
  }

  return (
    <DashboardCreate
      saveEntity={saveEntity}
      cancelEdit={onClose}
      entity={entity}
      defaultValues={defaultValues}
    ></DashboardCreate>
  );
}

export default DashboardDuplicateContainer;
